import DefaultTheme from 'react-dates/lib/theme/DefaultTheme';
import { getColor } from 'common/constants/_colors';

const borderColor = getColor('botticelli');

const datepickerSpanColor = {
  ...DefaultTheme.selectedSpan,
  borderColor,
  borderColor_active: borderColor,
  borderColor_hover: borderColor,
  backgroundColor: getColor('zircon'),
  backgroundColor_active: getColor('botticelli'),
  backgroundColor_hover: getColor('botticelli'),
  color: getColor('waikawaGray'),
  color_active: getColor('shark'),
  color_hover: getColor('shark')
};

export const datePickerStyles = {
  reactDates: {
    ...DefaultTheme.reactDates,
    border: {
      input: {
        ...DefaultTheme.reactDates.border.input,
        borderTopFocused: 0,
        borderLeftFocused: 0,
        borderBottomFocused: 0,
        borderRightFocused: 0
      },
      pickerInput: {
        ...DefaultTheme.reactDates.border.pickerInput,
        borderWidth: 2
      }
    },

    sizing: {
      inputWidth: '46%',
      inputWidth_small: '46%',
      arrowWidth: 0
    },

    spacing: {
      ...DefaultTheme.reactDates.spacing,
      displayTextPaddingTop: 9,
      displayTextPaddingBottom: 9,
      displayTextPaddingLeft: 'calc(50% - 45px)',
      displayTextPaddingRight: 5
    },

    color: {
      ...DefaultTheme.reactDates.color,
      highlighted: datepickerSpanColor,
      selected: { ...DefaultTheme.selected, ...datepickerSpanColor },
      selectedSpan: datepickerSpanColor,
      hoveredSpan: {
        backgroundColor: getColor('zircon'),
        backgroundColor_active: getColor('zircon'),
        backgroundColor_hover: getColor('zircon'),
        color: 'black',
        color_active: 'black',
        color_hover: 'black',
        borderColor,
        borderColor_active: borderColor,
        borderColor_hover: borderColor
      },
      blocked_calendar: {
        ...DefaultTheme.reactDates.color.blocked_calendar,
        backgroundColor: getColor('catskillGray'),
        backgroundColor_active: getColor('catskillGray'),
        backgroundColor_hover: getColor('catskillGray'),
        borderColor: getColor('catskillWhite'),
        color: getColor('silverSand'),
        color_active: getColor('silverSand'),
        color_hover: getColor('silverSand')
      }
    },
    font: {
      size: 14,
      captionSize: 18,
      input: {
        size: 15,
        weight: 200,
        lineHeight: '24px',
        size_small: 15,
        textAlign: 'center',
        lineHeight_small: '18px',
        letterSpacing_small: '0.2px',
        styleDisabled: 'italic'
      }
    }
  }
};
